import { useCallback } from 'react'
import { FilterMap } from 'hooks/lookup-field-hooks/use-filters-list'

import _ from 'lodash'

export interface IUseContextFilterCallbackArgs {
    fieldName: string,
    valueExpr: string,
    setContextFilter: Function,
    removeContextFilter: Function,
    getFirstCtxValue: Boolean,
}

export const useContextFilterCallback = ({
    fieldName,
    valueExpr,
    setContextFilter,
    removeContextFilter,
    getFirstCtxValue=false
}: IUseContextFilterCallbackArgs) => {
    const callback  = useCallback((val: any) => {
        if (Array.isArray(val) && getFirstCtxValue) {
            if (val.length > 0 && val[0] && typeof(val[0]) === 'object') {
                setContextFilter(fieldName, val[0][valueExpr])
            } else if (val.length === 0) {
                removeContextFilter(fieldName)
            }
        } else if ((!Array.isArray(val) && typeof(val) === 'object') || val === null) {
            if (val === null) { removeContextFilter(fieldName) }
            else { setContextFilter(fieldName, val[valueExpr]) }
        }
    }, [fieldName, valueExpr, setContextFilter, removeContextFilter, getFirstCtxValue])

    return callback
}

// todo: make this hook only update the localFilters map and the base lookup
// component will update the value based on that

export interface IUseContextSelfCallbackArgs {
    valueExpr: string,
    contextFilters: FilterMap,
    handleSelectionChanged: Function,
    setData: Function,
    loadItem: Function,
    load: Function,
    castToType: Function,
    selectionMode: 'single' | 'multi' | 'multicsv' | 'range' | 'singlerange',
}

export const useContextSelfCallback = ({
    valueExpr,
    contextFilters,
    handleSelectionChanged,
    setData,
    loadItem,
    load,
    castToType,
    selectionMode,
}: IUseContextSelfCallbackArgs) => {
    const callback = useCallback((val: any, force?: boolean) => {
        // todo: special case where we want to set the object from the context. To be used in drawer menu filters
        if (force && typeof(val) === 'object' && val) {
            setData((data: any) => {
                if (Array.isArray(val)) {
                    if (_.intersection(data.map((x: any) => x.HDR_ID), val.map((y: any) => y.HDR_ID)).length === val.length) {
                        return data
                    } else {
                        return val
                    }
                } else {
                    if (data.find((x: any) => x.HDR_ID === val.HDR_ID)) {
                        return data
                    } else {
                        return [val]
                    }
                }
            })
            handleSelectionChanged(val)
            return
        }

        if (selectionMode === 'range') {
            handleSelectionChanged(val)
        } else if (Array.isArray(val)) {
            if (val.length === 0) {
                handleSelectionChanged([])
                return
            }

            load(contextFilters)
                .then((data: any) => {
                    const _val = val.map((v: any) => typeof(v) === 'object' ? (v ? v[valueExpr] : v) : castToType(v))
                    handleSelectionChanged(data.filter((x: any) => _val.includes(x['NO'])))
                })

        } else {
            if (val === null) {
                handleSelectionChanged(null)
                return
            }

            loadItem(contextFilters, { [valueExpr.toLowerCase()]: val && typeof(val) === 'object' ? val[valueExpr] : val })
                .then((item: any) => handleSelectionChanged(item))
                .catch(() => null)
        }
    }, [valueExpr, contextFilters, loadItem, load, castToType, handleSelectionChanged, setData, selectionMode])

    return callback
}
